import { map, uniqBy } from "lodash";

type TagOption = { label: string; value: string };

export default function mergeComposerTags(
  tags: TagOption[] | undefined,
  extraTags: TagOption[] | undefined,
): { id: string; name: string }[] {
  return uniqBy(
    map([...(tags ?? []), ...(extraTags ?? [])], (tag) => ({
      id: tag.value,
      name: tag.label,
    })),
    "id",
  );
}
